import React from "react";
import { Modal } from "react-bootstrap";

const BotReactivationModal = ({
  show,
  onHide,
  onResume,
  onRestart,
  message,
  symbol,
  qty,
}) => {
  const fallbackMessage = symbol && qty !== undefined
    ? `The bot has an existing trade in progress. Would you like the bot to resume the trade or reset it?`
    : "";

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title className="modal-title-custom">Resume or Reset Trade</Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body-custom">
        {message || fallbackMessage}
      </Modal.Body>
      <Modal.Footer className="modal-footer-custom">
        <button className="blue-button" onClick={onResume}>
          Resume Trade
        </button>
        <button className="red-button" onClick={onRestart}>
          Reset Trade
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default BotReactivationModal;
